export default function HomeworkPage() {
  return (
    <div>
      <h1 style={{ fontSize: '1.8rem', fontWeight: 700, color: '#1a1c2c', marginBottom: '1rem' }}>
        📚 Tareas
      </h1>
      <p style={{ color: '#888' }}>Gestión de tareas pendiente de implementación.</p>
    </div>
  );
}
